import { createApp } from 'vue'
import App from './App.vue'
import { registerAxios } from '@/modules/Core/plugins/axios'
import { registerPlugins } from '@/modules/Core/plugins'
import './assets/styles/main.scss'
import '@/registerModules'

const app = createApp(App)

registerAxios(app)
registerPlugins(app)

app.mount('#app')
